export default __webpack_public_path__ + "static/media/eco-house.15b79cdb.png";